// extracted by mini-css-extract-plugin
export default {"quillContainer":"styles_quillContainer__xnN+U"};